import React from "react";
import './Footer.css';

function Footer() {
    return(
        <div className="footer">
            {/* <div className="footer_left">Made with Hate</div>
            <div className="footer_middle">Some links</div>
            <div className="footer_right">Copyright Kha Nguyen 2022</div> */}
            Last updated: 2024-04-01
        </div>
    );
}

export default Footer;